import $ from "jquery";

(function ($) {
  $("#navbar-main .dropdown-login")
    .on("show.bs.dropdown", function () {
      $('<div id="overlay"></div>').hide().appendTo("body").fadeIn("fast");
    })
    .on("hide.bs.dropdown", function () {
      $("#overlay").fadeOut(500, function () {
        $(this).remove();
      });
    });
})($, window);



// WEBPACK FOOTER //
// app/javascript/shared/navbar.js